import { render } from "./WidgetsList.vue?vue&type=template&id=2d7b1aae"
import script from "./WidgetsList.vue?vue&type=script&lang=js"
export * from "./WidgetsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__